import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GrowerBenchmarkFirmHomePeriodFieldsFragment = { __typename?: 'GrowerBenchmarkPeriod', approvedAt?: Types.TDateISO | null, cadence: Types.GrowerBenchmarkReportingCadence, comparisonPeriodId?: string | null, kind: Types.GrowerBenchmarkPeriodKind, label: string, periodId: string };

export type GrowerBenchmarkFirmHomeCohortFacetValueFieldsFragment = { __typename?: 'GrowerBenchmarkCohortFacetValue', facetKey: string, label: string, value: string, valueLabel: string };

export type GrowerBenchmarkFirmHomeCohortFieldsFragment = { __typename?: 'GrowerBenchmarkCohort', cohortKey: string, firmCount: number, floorFirmCount: number, isBelowFloor: boolean, label: string, reportedFirmCount: number, statisticsUpdatedAt?: Types.TDateISO | null, totalFirmCount: number, facets: Array<{ __typename?: 'GrowerBenchmarkCohortFacetValue', facetKey: string, label: string, value: string, valueLabel: string }> };

export type GrowerBenchmarkFirmHomeComparisonPointFieldsFragment = { __typename?: 'GrowerBenchmarkComparisonPoint', label: string, periodId: string, value: number };

export type GrowerBenchmarkFirmHomeFindingCauseFieldsFragment = { __typename?: 'GrowerBenchmarkFindingCause', change: number, direction: Types.GrowerBenchmarkMetricDirection, label: string, metricKey: string };

export type GrowerBenchmarkFirmHomeReviewerQuoteFieldsFragment = { __typename?: 'GrowerBenchmarkReviewerQuote', attributedToName: string, quote: string, writtenAt: Types.TDateISO };

export type GrowerBenchmarkFirmHomeFindingFieldsFragment = { __typename?: 'GrowerBenchmarkFinding', cohortMedian?: number | null, gapReference?: Types.GrowerBenchmarkGapReference | null, gapValue?: number | null, label: string, metricKey: string, sortOrder: number, status?: Types.GrowerBenchmarkFindingStatus | null, value?: number | null, workStatus?: Types.GrowerBenchmarkWorkStatus | null, cause?: { __typename?: 'GrowerBenchmarkFindingCause', change: number, direction: Types.GrowerBenchmarkMetricDirection, label: string, metricKey: string } | null, priorPeriods: Array<{ __typename?: 'GrowerBenchmarkComparisonPoint', label: string, periodId: string, value: number }>, reviewerQuote?: { __typename?: 'GrowerBenchmarkReviewerQuote', attributedToName: string, quote: string, writtenAt: Types.TDateISO } | null };

export type GrowerBenchmarkFirmHomeReviewFieldsFragment = { __typename?: 'GrowerBenchmarkPeriodReview', draftOrigin?: string | null, releasedAt?: Types.TDateISO | null, releasedByName?: string | null, reviewId?: string | null, sectionCount?: number | null, state: Types.GrowerBenchmarkReviewCardState };

export type GrowerBenchmarkFirmHomeMetricBandFieldsFragment = { __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null };

export type GrowerBenchmarkFirmHomeMetricDefinitionFieldsFragment = { __typename?: 'GrowerBenchmarkMetricDefinition', decimals: number, direction: Types.GrowerBenchmarkMetricDirection, formula: string, groupKey: string, inputs: Array<string>, label: string, metricKey: string, sortOrder: number, target?: number | null, unit: Types.GrowerBenchmarkMetricUnit, bands: Array<{ __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null }> };

export type GrowerBenchmarkFirmHomeCohortStatisticsFieldsFragment = { __typename?: 'GrowerBenchmarkCohortMetricStatistics', cohortKey: string, firmCount: number, floorFirmCount: number, isBelowFloor: boolean, lowerQuartile?: number | null, maximum?: number | null, median?: number | null, metricKey: string, minimum?: number | null, periodId: string, priorPeriodMedian?: number | null, reportedCount: number, topQuartile?: number | null };

export type GrowerBenchmarkFirmHomeMetricValueFieldsFragment = { __typename?: 'GrowerBenchmarkFirmMetricValue', metricKey: string, periodId: string, rank?: number | null, rankOf?: number | null, threeYearAverage?: number | null, value?: number | null, priorPeriods: Array<{ __typename?: 'GrowerBenchmarkComparisonPoint', label: string, periodId: string, value: number }> };

export type GrowerBenchmarkFirmHomeMetricPositionFieldsFragment = { __typename?: 'GrowerBenchmarkMetricPosition', verdict?: Types.GrowerBenchmarkPositionVerdict | null, definition: { __typename?: 'GrowerBenchmarkMetricDefinition', decimals: number, direction: Types.GrowerBenchmarkMetricDirection, formula: string, groupKey: string, inputs: Array<string>, label: string, metricKey: string, sortOrder: number, target?: number | null, unit: Types.GrowerBenchmarkMetricUnit, bands: Array<{ __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null }> }, self?: { __typename?: 'GrowerBenchmarkFirmMetricValue', metricKey: string, periodId: string, rank?: number | null, rankOf?: number | null, threeYearAverage?: number | null, value?: number | null, priorPeriods: Array<{ __typename?: 'GrowerBenchmarkComparisonPoint', label: string, periodId: string, value: number }> } | null, statistics: { __typename?: 'GrowerBenchmarkCohortMetricStatistics', cohortKey: string, firmCount: number, floorFirmCount: number, isBelowFloor: boolean, lowerQuartile?: number | null, maximum?: number | null, median?: number | null, metricKey: string, minimum?: number | null, periodId: string, priorPeriodMedian?: number | null, reportedCount: number, topQuartile?: number | null } };

export type GrowerBenchmarkFirmHomeMetricPointFieldsFragment = { __typename?: 'GrowerBenchmarkFirmMetricPoint', periodId: string, value?: number | null };

export type GrowerBenchmarkFirmHomeSeriesFieldsFragment = { __typename?: 'GrowerBenchmarkFirmMetricSeries', metricKey: string, points: Array<{ __typename?: 'GrowerBenchmarkFirmMetricPoint', periodId: string, value?: number | null }> };

export type GrowerBenchmarkFirmHomeFieldsFragment = { __typename?: 'GrowerBenchmarkFirmHome', communityId: string, firmId: string, segment: Types.GrowerBenchmarkCommunitySegment, selfFirmLabel: string, cohort: { __typename?: 'GrowerBenchmarkCohort', cohortKey: string, firmCount: number, floorFirmCount: number, isBelowFloor: boolean, label: string, reportedFirmCount: number, statisticsUpdatedAt?: Types.TDateISO | null, totalFirmCount: number, facets: Array<{ __typename?: 'GrowerBenchmarkCohortFacetValue', facetKey: string, label: string, value: string, valueLabel: string }> }, comparisonPeriod?: { __typename?: 'GrowerBenchmarkPeriod', approvedAt?: Types.TDateISO | null, cadence: Types.GrowerBenchmarkReportingCadence, comparisonPeriodId?: string | null, kind: Types.GrowerBenchmarkPeriodKind, label: string, periodId: string } | null, findings: Array<{ __typename?: 'GrowerBenchmarkFinding', cohortMedian?: number | null, gapReference?: Types.GrowerBenchmarkGapReference | null, gapValue?: number | null, label: string, metricKey: string, sortOrder: number, status?: Types.GrowerBenchmarkFindingStatus | null, value?: number | null, workStatus?: Types.GrowerBenchmarkWorkStatus | null, cause?: { __typename?: 'GrowerBenchmarkFindingCause', change: number, direction: Types.GrowerBenchmarkMetricDirection, label: string, metricKey: string } | null, priorPeriods: Array<{ __typename?: 'GrowerBenchmarkComparisonPoint', label: string, periodId: string, value: number }>, reviewerQuote?: { __typename?: 'GrowerBenchmarkReviewerQuote', attributedToName: string, quote: string, writtenAt: Types.TDateISO } | null }>, headlineMetrics: Array<{ __typename?: 'GrowerBenchmarkMetricPosition', verdict?: Types.GrowerBenchmarkPositionVerdict | null, definition: { __typename?: 'GrowerBenchmarkMetricDefinition', decimals: number, direction: Types.GrowerBenchmarkMetricDirection, formula: string, groupKey: string, inputs: Array<string>, label: string, metricKey: string, sortOrder: number, target?: number | null, unit: Types.GrowerBenchmarkMetricUnit, bands: Array<{ __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null }> }, self?: { __typename?: 'GrowerBenchmarkFirmMetricValue', metricKey: string, periodId: string, rank?: number | null, rankOf?: number | null, threeYearAverage?: number | null, value?: number | null, priorPeriods: Array<{ __typename?: 'GrowerBenchmarkComparisonPoint', label: string, periodId: string, value: number }> } | null, statistics: { __typename?: 'GrowerBenchmarkCohortMetricStatistics', cohortKey: string, firmCount: number, floorFirmCount: number, isBelowFloor: boolean, lowerQuartile?: number | null, maximum?: number | null, median?: number | null, metricKey: string, minimum?: number | null, periodId: string, priorPeriodMedian?: number | null, reportedCount: number, topQuartile?: number | null } }>, period: { __typename?: 'GrowerBenchmarkPeriod', approvedAt?: Types.TDateISO | null, cadence: Types.GrowerBenchmarkReportingCadence, comparisonPeriodId?: string | null, kind: Types.GrowerBenchmarkPeriodKind, label: string, periodId: string }, positionMetrics: Array<{ __typename?: 'GrowerBenchmarkMetricPosition', verdict?: Types.GrowerBenchmarkPositionVerdict | null, definition: { __typename?: 'GrowerBenchmarkMetricDefinition', decimals: number, direction: Types.GrowerBenchmarkMetricDirection, formula: string, groupKey: string, inputs: Array<string>, label: string, metricKey: string, sortOrder: number, target?: number | null, unit: Types.GrowerBenchmarkMetricUnit, bands: Array<{ __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null }> }, self?: { __typename?: 'GrowerBenchmarkFirmMetricValue', metricKey: string, periodId: string, rank?: number | null, rankOf?: number | null, threeYearAverage?: number | null, value?: number | null, priorPeriods: Array<{ __typename?: 'GrowerBenchmarkComparisonPoint', label: string, periodId: string, value: number }> } | null, statistics: { __typename?: 'GrowerBenchmarkCohortMetricStatistics', cohortKey: string, firmCount: number, floorFirmCount: number, isBelowFloor: boolean, lowerQuartile?: number | null, maximum?: number | null, median?: number | null, metricKey: string, minimum?: number | null, periodId: string, priorPeriodMedian?: number | null, reportedCount: number, topQuartile?: number | null } }>, review: { __typename?: 'GrowerBenchmarkPeriodReview', draftOrigin?: string | null, releasedAt?: Types.TDateISO | null, releasedByName?: string | null, reviewId?: string | null, sectionCount?: number | null, state: Types.GrowerBenchmarkReviewCardState }, series: Array<{ __typename?: 'GrowerBenchmarkFirmMetricSeries', metricKey: string, points: Array<{ __typename?: 'GrowerBenchmarkFirmMetricPoint', periodId: string, value?: number | null }> }> };

export type GrowerBenchmarkFirmHomeQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
  periodId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GrowerBenchmarkFirmHomeQuery = { __typename?: 'Query', growerBenchmarkFirmHome?: { __typename?: 'GrowerBenchmarkFirmHome', communityId: string, firmId: string, segment: Types.GrowerBenchmarkCommunitySegment, selfFirmLabel: string, cohort: { __typename?: 'GrowerBenchmarkCohort', cohortKey: string, firmCount: number, floorFirmCount: number, isBelowFloor: boolean, label: string, reportedFirmCount: number, statisticsUpdatedAt?: Types.TDateISO | null, totalFirmCount: number, facets: Array<{ __typename?: 'GrowerBenchmarkCohortFacetValue', facetKey: string, label: string, value: string, valueLabel: string }> }, comparisonPeriod?: { __typename?: 'GrowerBenchmarkPeriod', approvedAt?: Types.TDateISO | null, cadence: Types.GrowerBenchmarkReportingCadence, comparisonPeriodId?: string | null, kind: Types.GrowerBenchmarkPeriodKind, label: string, periodId: string } | null, findings: Array<{ __typename?: 'GrowerBenchmarkFinding', cohortMedian?: number | null, gapReference?: Types.GrowerBenchmarkGapReference | null, gapValue?: number | null, label: string, metricKey: string, sortOrder: number, status?: Types.GrowerBenchmarkFindingStatus | null, value?: number | null, workStatus?: Types.GrowerBenchmarkWorkStatus | null, cause?: { __typename?: 'GrowerBenchmarkFindingCause', change: number, direction: Types.GrowerBenchmarkMetricDirection, label: string, metricKey: string } | null, priorPeriods: Array<{ __typename?: 'GrowerBenchmarkComparisonPoint', label: string, periodId: string, value: number }>, reviewerQuote?: { __typename?: 'GrowerBenchmarkReviewerQuote', attributedToName: string, quote: string, writtenAt: Types.TDateISO } | null }>, headlineMetrics: Array<{ __typename?: 'GrowerBenchmarkMetricPosition', verdict?: Types.GrowerBenchmarkPositionVerdict | null, definition: { __typename?: 'GrowerBenchmarkMetricDefinition', decimals: number, direction: Types.GrowerBenchmarkMetricDirection, formula: string, groupKey: string, inputs: Array<string>, label: string, metricKey: string, sortOrder: number, target?: number | null, unit: Types.GrowerBenchmarkMetricUnit, bands: Array<{ __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null }> }, self?: { __typename?: 'GrowerBenchmarkFirmMetricValue', metricKey: string, periodId: string, rank?: number | null, rankOf?: number | null, threeYearAverage?: number | null, value?: number | null, priorPeriods: Array<{ __typename?: 'GrowerBenchmarkComparisonPoint', label: string, periodId: string, value: number }> } | null, statistics: { __typename?: 'GrowerBenchmarkCohortMetricStatistics', cohortKey: string, firmCount: number, floorFirmCount: number, isBelowFloor: boolean, lowerQuartile?: number | null, maximum?: number | null, median?: number | null, metricKey: string, minimum?: number | null, periodId: string, priorPeriodMedian?: number | null, reportedCount: number, topQuartile?: number | null } }>, period: { __typename?: 'GrowerBenchmarkPeriod', approvedAt?: Types.TDateISO | null, cadence: Types.GrowerBenchmarkReportingCadence, comparisonPeriodId?: string | null, kind: Types.GrowerBenchmarkPeriodKind, label: string, periodId: string }, positionMetrics: Array<{ __typename?: 'GrowerBenchmarkMetricPosition', verdict?: Types.GrowerBenchmarkPositionVerdict | null, definition: { __typename?: 'GrowerBenchmarkMetricDefinition', decimals: number, direction: Types.GrowerBenchmarkMetricDirection, formula: string, groupKey: string, inputs: Array<string>, label: string, metricKey: string, sortOrder: number, target?: number | null, unit: Types.GrowerBenchmarkMetricUnit, bands: Array<{ __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null }> }, self?: { __typename?: 'GrowerBenchmarkFirmMetricValue', metricKey: string, periodId: string, rank?: number | null, rankOf?: number | null, threeYearAverage?: number | null, value?: number | null, priorPeriods: Array<{ __typename?: 'GrowerBenchmarkComparisonPoint', label: string, periodId: string, value: number }> } | null, statistics: { __typename?: 'GrowerBenchmarkCohortMetricStatistics', cohortKey: string, firmCount: number, floorFirmCount: number, isBelowFloor: boolean, lowerQuartile?: number | null, maximum?: number | null, median?: number | null, metricKey: string, minimum?: number | null, periodId: string, priorPeriodMedian?: number | null, reportedCount: number, topQuartile?: number | null } }>, review: { __typename?: 'GrowerBenchmarkPeriodReview', draftOrigin?: string | null, releasedAt?: Types.TDateISO | null, releasedByName?: string | null, reviewId?: string | null, sectionCount?: number | null, state: Types.GrowerBenchmarkReviewCardState }, series: Array<{ __typename?: 'GrowerBenchmarkFirmMetricSeries', metricKey: string, points: Array<{ __typename?: 'GrowerBenchmarkFirmMetricPoint', periodId: string, value?: number | null }> }> } | null };

export type GrowerBenchmarkPeriodsQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
}>;


export type GrowerBenchmarkPeriodsQuery = { __typename?: 'Query', growerBenchmarkPeriods: Array<{ __typename?: 'GrowerBenchmarkPeriod', approvedAt?: Types.TDateISO | null, cadence: Types.GrowerBenchmarkReportingCadence, comparisonPeriodId?: string | null, kind: Types.GrowerBenchmarkPeriodKind, label: string, periodId: string }> };

export const GrowerBenchmarkFirmHomeCohortFacetValueFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeCohortFacetValueFields on GrowerBenchmarkCohortFacetValue {
  facetKey
  label
  value
  valueLabel
}
    `, {"fragmentName":"GrowerBenchmarkFirmHomeCohortFacetValueFields"});
export const GrowerBenchmarkFirmHomeCohortFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeCohortFields on GrowerBenchmarkCohort {
  cohortKey
  facets {
    ...GrowerBenchmarkFirmHomeCohortFacetValueFields
  }
  firmCount
  floorFirmCount
  isBelowFloor
  label
  reportedFirmCount
  statisticsUpdatedAt
  totalFirmCount
}
    fragment GrowerBenchmarkFirmHomeCohortFacetValueFields on GrowerBenchmarkCohortFacetValue {
  facetKey
  label
  value
  valueLabel
}`, {"fragmentName":"GrowerBenchmarkFirmHomeCohortFields"});
export const GrowerBenchmarkFirmHomePeriodFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomePeriodFields on GrowerBenchmarkPeriod {
  approvedAt
  cadence
  comparisonPeriodId
  kind
  label
  periodId
}
    `, {"fragmentName":"GrowerBenchmarkFirmHomePeriodFields"});
export const GrowerBenchmarkFirmHomeFindingCauseFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeFindingCauseFields on GrowerBenchmarkFindingCause {
  change
  direction
  label
  metricKey
}
    `, {"fragmentName":"GrowerBenchmarkFirmHomeFindingCauseFields"});
export const GrowerBenchmarkFirmHomeComparisonPointFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeComparisonPointFields on GrowerBenchmarkComparisonPoint {
  label
  periodId
  value
}
    `, {"fragmentName":"GrowerBenchmarkFirmHomeComparisonPointFields"});
export const GrowerBenchmarkFirmHomeReviewerQuoteFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeReviewerQuoteFields on GrowerBenchmarkReviewerQuote {
  attributedToName
  quote
  writtenAt
}
    `, {"fragmentName":"GrowerBenchmarkFirmHomeReviewerQuoteFields"});
export const GrowerBenchmarkFirmHomeFindingFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeFindingFields on GrowerBenchmarkFinding {
  cause {
    ...GrowerBenchmarkFirmHomeFindingCauseFields
  }
  cohortMedian
  gapReference
  gapValue
  label
  metricKey
  priorPeriods {
    ...GrowerBenchmarkFirmHomeComparisonPointFields
  }
  reviewerQuote {
    ...GrowerBenchmarkFirmHomeReviewerQuoteFields
  }
  sortOrder
  status
  value
  workStatus
}
    fragment GrowerBenchmarkFirmHomeComparisonPointFields on GrowerBenchmarkComparisonPoint {
  label
  periodId
  value
}
fragment GrowerBenchmarkFirmHomeFindingCauseFields on GrowerBenchmarkFindingCause {
  change
  direction
  label
  metricKey
}
fragment GrowerBenchmarkFirmHomeReviewerQuoteFields on GrowerBenchmarkReviewerQuote {
  attributedToName
  quote
  writtenAt
}`, {"fragmentName":"GrowerBenchmarkFirmHomeFindingFields"});
export const GrowerBenchmarkFirmHomeMetricBandFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}
    `, {"fragmentName":"GrowerBenchmarkFirmHomeMetricBandFields"});
export const GrowerBenchmarkFirmHomeMetricDefinitionFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeMetricDefinitionFields on GrowerBenchmarkMetricDefinition {
  bands {
    ...GrowerBenchmarkFirmHomeMetricBandFields
  }
  decimals
  direction
  formula
  groupKey
  inputs
  label
  metricKey
  sortOrder
  target
  unit
}
    fragment GrowerBenchmarkFirmHomeMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}`, {"fragmentName":"GrowerBenchmarkFirmHomeMetricDefinitionFields"});
export const GrowerBenchmarkFirmHomeMetricValueFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeMetricValueFields on GrowerBenchmarkFirmMetricValue {
  metricKey
  periodId
  priorPeriods {
    ...GrowerBenchmarkFirmHomeComparisonPointFields
  }
  rank
  rankOf
  threeYearAverage
  value
}
    fragment GrowerBenchmarkFirmHomeComparisonPointFields on GrowerBenchmarkComparisonPoint {
  label
  periodId
  value
}`, {"fragmentName":"GrowerBenchmarkFirmHomeMetricValueFields"});
export const GrowerBenchmarkFirmHomeCohortStatisticsFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeCohortStatisticsFields on GrowerBenchmarkCohortMetricStatistics {
  cohortKey
  firmCount
  floorFirmCount
  isBelowFloor
  lowerQuartile
  maximum
  median
  metricKey
  minimum
  periodId
  priorPeriodMedian
  reportedCount
  topQuartile
}
    `, {"fragmentName":"GrowerBenchmarkFirmHomeCohortStatisticsFields"});
export const GrowerBenchmarkFirmHomeMetricPositionFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeMetricPositionFields on GrowerBenchmarkMetricPosition {
  definition {
    ...GrowerBenchmarkFirmHomeMetricDefinitionFields
  }
  self {
    ...GrowerBenchmarkFirmHomeMetricValueFields
  }
  statistics {
    ...GrowerBenchmarkFirmHomeCohortStatisticsFields
  }
  verdict
}
    fragment GrowerBenchmarkFirmHomeComparisonPointFields on GrowerBenchmarkComparisonPoint {
  label
  periodId
  value
}
fragment GrowerBenchmarkFirmHomeMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}
fragment GrowerBenchmarkFirmHomeMetricDefinitionFields on GrowerBenchmarkMetricDefinition {
  bands {
    ...GrowerBenchmarkFirmHomeMetricBandFields
  }
  decimals
  direction
  formula
  groupKey
  inputs
  label
  metricKey
  sortOrder
  target
  unit
}
fragment GrowerBenchmarkFirmHomeCohortStatisticsFields on GrowerBenchmarkCohortMetricStatistics {
  cohortKey
  firmCount
  floorFirmCount
  isBelowFloor
  lowerQuartile
  maximum
  median
  metricKey
  minimum
  periodId
  priorPeriodMedian
  reportedCount
  topQuartile
}
fragment GrowerBenchmarkFirmHomeMetricValueFields on GrowerBenchmarkFirmMetricValue {
  metricKey
  periodId
  priorPeriods {
    ...GrowerBenchmarkFirmHomeComparisonPointFields
  }
  rank
  rankOf
  threeYearAverage
  value
}`, {"fragmentName":"GrowerBenchmarkFirmHomeMetricPositionFields"});
export const GrowerBenchmarkFirmHomeReviewFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeReviewFields on GrowerBenchmarkPeriodReview {
  draftOrigin
  releasedAt
  releasedByName
  reviewId
  sectionCount
  state
}
    `, {"fragmentName":"GrowerBenchmarkFirmHomeReviewFields"});
export const GrowerBenchmarkFirmHomeMetricPointFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeMetricPointFields on GrowerBenchmarkFirmMetricPoint {
  periodId
  value
}
    `, {"fragmentName":"GrowerBenchmarkFirmHomeMetricPointFields"});
export const GrowerBenchmarkFirmHomeSeriesFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeSeriesFields on GrowerBenchmarkFirmMetricSeries {
  metricKey
  points {
    ...GrowerBenchmarkFirmHomeMetricPointFields
  }
}
    fragment GrowerBenchmarkFirmHomeMetricPointFields on GrowerBenchmarkFirmMetricPoint {
  periodId
  value
}`, {"fragmentName":"GrowerBenchmarkFirmHomeSeriesFields"});
export const GrowerBenchmarkFirmHomeFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmHomeFields on GrowerBenchmarkFirmHome {
  cohort {
    ...GrowerBenchmarkFirmHomeCohortFields
  }
  communityId
  comparisonPeriod {
    ...GrowerBenchmarkFirmHomePeriodFields
  }
  findings {
    ...GrowerBenchmarkFirmHomeFindingFields
  }
  firmId
  headlineMetrics {
    ...GrowerBenchmarkFirmHomeMetricPositionFields
  }
  period {
    ...GrowerBenchmarkFirmHomePeriodFields
  }
  positionMetrics {
    ...GrowerBenchmarkFirmHomeMetricPositionFields
  }
  review {
    ...GrowerBenchmarkFirmHomeReviewFields
  }
  segment
  selfFirmLabel
  series {
    ...GrowerBenchmarkFirmHomeSeriesFields
  }
}
    fragment GrowerBenchmarkFirmHomePeriodFields on GrowerBenchmarkPeriod {
  approvedAt
  cadence
  comparisonPeriodId
  kind
  label
  periodId
}
fragment GrowerBenchmarkFirmHomeCohortFacetValueFields on GrowerBenchmarkCohortFacetValue {
  facetKey
  label
  value
  valueLabel
}
fragment GrowerBenchmarkFirmHomeCohortFields on GrowerBenchmarkCohort {
  cohortKey
  facets {
    ...GrowerBenchmarkFirmHomeCohortFacetValueFields
  }
  firmCount
  floorFirmCount
  isBelowFloor
  label
  reportedFirmCount
  statisticsUpdatedAt
  totalFirmCount
}
fragment GrowerBenchmarkFirmHomeComparisonPointFields on GrowerBenchmarkComparisonPoint {
  label
  periodId
  value
}
fragment GrowerBenchmarkFirmHomeFindingCauseFields on GrowerBenchmarkFindingCause {
  change
  direction
  label
  metricKey
}
fragment GrowerBenchmarkFirmHomeReviewerQuoteFields on GrowerBenchmarkReviewerQuote {
  attributedToName
  quote
  writtenAt
}
fragment GrowerBenchmarkFirmHomeFindingFields on GrowerBenchmarkFinding {
  cause {
    ...GrowerBenchmarkFirmHomeFindingCauseFields
  }
  cohortMedian
  gapReference
  gapValue
  label
  metricKey
  priorPeriods {
    ...GrowerBenchmarkFirmHomeComparisonPointFields
  }
  reviewerQuote {
    ...GrowerBenchmarkFirmHomeReviewerQuoteFields
  }
  sortOrder
  status
  value
  workStatus
}
fragment GrowerBenchmarkFirmHomeReviewFields on GrowerBenchmarkPeriodReview {
  draftOrigin
  releasedAt
  releasedByName
  reviewId
  sectionCount
  state
}
fragment GrowerBenchmarkFirmHomeMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}
fragment GrowerBenchmarkFirmHomeMetricDefinitionFields on GrowerBenchmarkMetricDefinition {
  bands {
    ...GrowerBenchmarkFirmHomeMetricBandFields
  }
  decimals
  direction
  formula
  groupKey
  inputs
  label
  metricKey
  sortOrder
  target
  unit
}
fragment GrowerBenchmarkFirmHomeCohortStatisticsFields on GrowerBenchmarkCohortMetricStatistics {
  cohortKey
  firmCount
  floorFirmCount
  isBelowFloor
  lowerQuartile
  maximum
  median
  metricKey
  minimum
  periodId
  priorPeriodMedian
  reportedCount
  topQuartile
}
fragment GrowerBenchmarkFirmHomeMetricValueFields on GrowerBenchmarkFirmMetricValue {
  metricKey
  periodId
  priorPeriods {
    ...GrowerBenchmarkFirmHomeComparisonPointFields
  }
  rank
  rankOf
  threeYearAverage
  value
}
fragment GrowerBenchmarkFirmHomeMetricPositionFields on GrowerBenchmarkMetricPosition {
  definition {
    ...GrowerBenchmarkFirmHomeMetricDefinitionFields
  }
  self {
    ...GrowerBenchmarkFirmHomeMetricValueFields
  }
  statistics {
    ...GrowerBenchmarkFirmHomeCohortStatisticsFields
  }
  verdict
}
fragment GrowerBenchmarkFirmHomeMetricPointFields on GrowerBenchmarkFirmMetricPoint {
  periodId
  value
}
fragment GrowerBenchmarkFirmHomeSeriesFields on GrowerBenchmarkFirmMetricSeries {
  metricKey
  points {
    ...GrowerBenchmarkFirmHomeMetricPointFields
  }
}`, {"fragmentName":"GrowerBenchmarkFirmHomeFields"});
export const GrowerBenchmarkFirmHomeDocument = new TypedDocumentString(`
    query GrowerBenchmarkFirmHome($communityId: String!, $periodId: String) {
  growerBenchmarkFirmHome(communityId: $communityId, periodId: $periodId) {
    ...GrowerBenchmarkFirmHomeFields
  }
}
    fragment GrowerBenchmarkFirmHomePeriodFields on GrowerBenchmarkPeriod {
  approvedAt
  cadence
  comparisonPeriodId
  kind
  label
  periodId
}
fragment GrowerBenchmarkFirmHomeCohortFacetValueFields on GrowerBenchmarkCohortFacetValue {
  facetKey
  label
  value
  valueLabel
}
fragment GrowerBenchmarkFirmHomeCohortFields on GrowerBenchmarkCohort {
  cohortKey
  facets {
    ...GrowerBenchmarkFirmHomeCohortFacetValueFields
  }
  firmCount
  floorFirmCount
  isBelowFloor
  label
  reportedFirmCount
  statisticsUpdatedAt
  totalFirmCount
}
fragment GrowerBenchmarkFirmHomeComparisonPointFields on GrowerBenchmarkComparisonPoint {
  label
  periodId
  value
}
fragment GrowerBenchmarkFirmHomeFindingCauseFields on GrowerBenchmarkFindingCause {
  change
  direction
  label
  metricKey
}
fragment GrowerBenchmarkFirmHomeReviewerQuoteFields on GrowerBenchmarkReviewerQuote {
  attributedToName
  quote
  writtenAt
}
fragment GrowerBenchmarkFirmHomeFindingFields on GrowerBenchmarkFinding {
  cause {
    ...GrowerBenchmarkFirmHomeFindingCauseFields
  }
  cohortMedian
  gapReference
  gapValue
  label
  metricKey
  priorPeriods {
    ...GrowerBenchmarkFirmHomeComparisonPointFields
  }
  reviewerQuote {
    ...GrowerBenchmarkFirmHomeReviewerQuoteFields
  }
  sortOrder
  status
  value
  workStatus
}
fragment GrowerBenchmarkFirmHomeReviewFields on GrowerBenchmarkPeriodReview {
  draftOrigin
  releasedAt
  releasedByName
  reviewId
  sectionCount
  state
}
fragment GrowerBenchmarkFirmHomeMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}
fragment GrowerBenchmarkFirmHomeMetricDefinitionFields on GrowerBenchmarkMetricDefinition {
  bands {
    ...GrowerBenchmarkFirmHomeMetricBandFields
  }
  decimals
  direction
  formula
  groupKey
  inputs
  label
  metricKey
  sortOrder
  target
  unit
}
fragment GrowerBenchmarkFirmHomeCohortStatisticsFields on GrowerBenchmarkCohortMetricStatistics {
  cohortKey
  firmCount
  floorFirmCount
  isBelowFloor
  lowerQuartile
  maximum
  median
  metricKey
  minimum
  periodId
  priorPeriodMedian
  reportedCount
  topQuartile
}
fragment GrowerBenchmarkFirmHomeMetricValueFields on GrowerBenchmarkFirmMetricValue {
  metricKey
  periodId
  priorPeriods {
    ...GrowerBenchmarkFirmHomeComparisonPointFields
  }
  rank
  rankOf
  threeYearAverage
  value
}
fragment GrowerBenchmarkFirmHomeMetricPositionFields on GrowerBenchmarkMetricPosition {
  definition {
    ...GrowerBenchmarkFirmHomeMetricDefinitionFields
  }
  self {
    ...GrowerBenchmarkFirmHomeMetricValueFields
  }
  statistics {
    ...GrowerBenchmarkFirmHomeCohortStatisticsFields
  }
  verdict
}
fragment GrowerBenchmarkFirmHomeMetricPointFields on GrowerBenchmarkFirmMetricPoint {
  periodId
  value
}
fragment GrowerBenchmarkFirmHomeSeriesFields on GrowerBenchmarkFirmMetricSeries {
  metricKey
  points {
    ...GrowerBenchmarkFirmHomeMetricPointFields
  }
}
fragment GrowerBenchmarkFirmHomeFields on GrowerBenchmarkFirmHome {
  cohort {
    ...GrowerBenchmarkFirmHomeCohortFields
  }
  communityId
  comparisonPeriod {
    ...GrowerBenchmarkFirmHomePeriodFields
  }
  findings {
    ...GrowerBenchmarkFirmHomeFindingFields
  }
  firmId
  headlineMetrics {
    ...GrowerBenchmarkFirmHomeMetricPositionFields
  }
  period {
    ...GrowerBenchmarkFirmHomePeriodFields
  }
  positionMetrics {
    ...GrowerBenchmarkFirmHomeMetricPositionFields
  }
  review {
    ...GrowerBenchmarkFirmHomeReviewFields
  }
  segment
  selfFirmLabel
  series {
    ...GrowerBenchmarkFirmHomeSeriesFields
  }
}`);
export const GrowerBenchmarkPeriodsDocument = new TypedDocumentString(`
    query GrowerBenchmarkPeriods($communityId: String!) {
  growerBenchmarkPeriods(communityId: $communityId) {
    ...GrowerBenchmarkFirmHomePeriodFields
  }
}
    fragment GrowerBenchmarkFirmHomePeriodFields on GrowerBenchmarkPeriod {
  approvedAt
  cadence
  comparisonPeriodId
  kind
  label
  periodId
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GrowerBenchmarkFirmHome: build.query<GrowerBenchmarkFirmHomeQuery, GrowerBenchmarkFirmHomeQueryVariables>({
      query: (variables) => ({ document: GrowerBenchmarkFirmHomeDocument, variables })
    }),
    GrowerBenchmarkPeriods: build.query<GrowerBenchmarkPeriodsQuery, GrowerBenchmarkPeriodsQueryVariables>({
      query: (variables) => ({ document: GrowerBenchmarkPeriodsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGrowerBenchmarkFirmHomeQuery, useLazyGrowerBenchmarkFirmHomeQuery, useGrowerBenchmarkPeriodsQuery, useLazyGrowerBenchmarkPeriodsQuery } = injectedRtkApi;
